module.exports = __webpack_public_path__ + "static/img/23-finance.7cafcf9.png";


//////////////////
// WEBPACK FOOTER
// ./static/Icon/23-finance.png
// module id = B71C
// module chunks = 1